import React from "react";
import style from "./AlumniDiscoverWays.module.css";

interface TitleDescriptionSection {
  id: number;
  title: string;
  description: string;
}

interface AlumniDiscoverWaysProps {
  data?: TitleDescriptionSection;
}

const AlumniDiscoverWays: React.FC<AlumniDiscoverWaysProps> = ({ data }) => {
  if (!data) return null;

  const { title, description } = data;

  return (
    <div className={style.discoverways} id="AlumniAssociation">
      <div className="container">
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default AlumniDiscoverWays;
